import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Routes } from 'react-router-dom';
import { App } from './app';
import { LayoutRoutes } from './views/layout';
import { TvDashboardView } from './views/tvDashboard';
/** The routes of the application. */
export const AppRoutes = () => (_jsx(App, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/tv/dashboard/:queueId", element: _jsx(TvDashboardView, {}) }), _jsx(Route, { path: "/*", element: _jsx(LayoutRoutes, {}) })] }) }));
